import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import type { CommunityEssentialFolderModel } from '@/models'
import { resetQueries } from '@/utils/api/reset-queries'

import { GET_ALL_FOLDERS_BASE_QUERY_KEY } from './get-all-folders'
import { GET_FOLDER_CONTENT_BASE_QUERY_KEY } from './get-folder-content'

export interface UpdateFolderRequest {
  folderId: number
  name: string
  parentFolderId: number | null
  position?: number
}

export const updateFolder = async (data: UpdateFolderRequest) => {
  const { folderId, ...body } = data
  const response = await authAPI.put<CommunityEssentialFolderModel[]>(
    `/building-essential/folder/${folderId}`,
    body,
  )
  return response.data
}

export const useUpdateFolder = () => {
  return useMutation({
    mutationFn: updateFolder,
    onSuccess: () =>
      resetQueries([GET_FOLDER_CONTENT_BASE_QUERY_KEY], [GET_ALL_FOLDERS_BASE_QUERY_KEY]),
  })
}
